/**
 * Lazy Images
 * =================================
 *
 * Loads images as they are scrolled into view. Reducing the number
 * of requests made, therefore improving page load time and performance.
 *
 */

import $ from 'qwery';
import { isInViewport } from '../../helpers/domHelper';
import { logImageLoadError } from '../../imageLogger';

let lazy = [];
const lazyDataAttr = 'data-lazy-image-src';
const getLazyImages = () => $(`[${lazyDataAttr}]`);

function setup () {
    if (getLazyImages().length > 0) {
        lazyImages();

        window.addEventListener('scroll', lazyImages);
        window.addEventListener('resize', lazyImages);
    }
}

function filterLoaded () {
    lazy = lazy.filter(img => img.getAttribute(lazyDataAttr));
}

function loadImage (element, handleError) {
    if (!isInViewport(element)) return;
    const originalImgUrl = (element instanceof HTMLImageElement)
        ? element.src
        : element.style.backgroundImage;
    const imgUrl = element.getAttribute(lazyDataAttr);

    if (imgUrl) {
        element.addEventListener('error', () => {
            handleError(element);
            if (element instanceof HTMLImageElement) {
                element.src = originalImgUrl;
            } else {
                element.style.backgroundImage = `url(${originalImgUrl})`;
            }
        });

        if (element instanceof HTMLImageElement) {
            element.src = imgUrl;
        } else {
            element.style.backgroundImage = `url(${imgUrl})`;
        }

        element.removeAttribute(lazyDataAttr);
    }
}

function lazyImages () {
    lazy = getLazyImages();

    if (lazy.length > 0) {
        lazy.forEach(img => {
            loadImage(img, logImageLoadError);
        });
        filterLoaded();
    }
}

setup();

export {
    lazyImages
};
